import React, { useContext } from "react";
import { Grid, Typography, Card, CardContent, IconButton } from "@mui/material";
import { ReactComponent as CopyIcon } from "./../../../assets/Icons/copy.svg";

import { warm } from "style/color";
import { NetaSetting } from "constants/neta-settings";
import { NetaSettingContext } from "providers/netaSettingsProvider";

export const SecuritiesPaymentDetails: React.FC = () => {
  const NETA = useContext<NetaSetting>(NetaSettingContext);

  const customIconButton = (text: string) => {
    return (
      <IconButton
        onClick={() => {
          navigator.clipboard.writeText(text);
        }}
        sx={{
          padding: 0,
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}
      >
        <CopyIcon />
      </IconButton>
    );
  };
  return (
    <Grid item xs={12} sm={12}>
      <Card sx={{ backgroundColor: warm[100], boxShadow: "none" }}>
        <CardContent sx={{ p: 5, "&:last-child": { pb: 5 } }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3} md={3}>
              <Typography
                className="title"
                variant="smallCopy"
                sx={{ color: `neutral.dark` }}
              >
                Broker name
              </Typography>
            </Grid>
            <Grid item xs={10} sm={5} md={4}>
              <Typography variant="bodyCopyBold" sx={{ color: `neutral.main` }}>
                {NETA.brokerName}
              </Typography>
            </Grid>
            <Grid item xs={2} sm={2} md={2}>
              {customIconButton(NETA.brokerName)}
            </Grid>
            <Grid item xs={0} sm={0} md={2}></Grid>
            <Grid item xs={12} sm={3} md={3}>
              <Typography
                className="title"
                variant="smallCopy"
                sx={{ color: `neutral.dark` }}
              >
                DTC number
              </Typography>
            </Grid>
            <Grid item xs={10} sm={5} md={4}>
              <Typography variant="bodyCopyBold" sx={{ color: `neutral.main` }}>
                {NETA.DTCNumber}
              </Typography>
            </Grid>
            <Grid item xs={2} sm={2} md={2}>
              {customIconButton(NETA.DTCNumber)}
            </Grid>
            <Grid item xs={0} sm={0} md={1}></Grid>
            <Grid item xs={12} sm={3} md={3}>
              <Typography
                className="title"
                variant="smallCopy"
                sx={{ color: `neutral.dark` }}
              >
                Account Number
              </Typography>
            </Grid>
            <Grid item xs={10} sm={5} md={4}>
              <Typography variant="bodyCopyBold" sx={{ color: `neutral.main` }}>
                {NETA.accountNumber}
              </Typography>
            </Grid>
            <Grid item xs={2} sm={2} md={2}>
              {customIconButton(NETA.accountNumber)}
            </Grid>
            <Grid item xs={0} sm={0} md={1}></Grid>
            <Grid item xs={12} sm={3} md={3}>
              <Typography
                className="title"
                variant="smallCopy"
                sx={{ color: `neutral.dark` }}
              >
                Account Name
              </Typography>
            </Grid>
            <Grid item xs={10} sm={5} md={4}>
              <Typography variant="bodyCopyBold" sx={{ color: `neutral.main` }}>
                {NETA.name}
              </Typography>
            </Grid>
            <Grid item xs={2} sm={2} md={2}>
              {customIconButton(NETA.name)}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};
